import type { Socket } from 'socket.io-client';
import { io } from 'socket.io-client';
import * as parser from 'socket.io-msgpack-parser';

import { ConnectionId } from '/imports/domain';
import type {
  ClientToServerEvents,
  ServerToClientEvents,
} from '/imports/startup/server/shared/socket';
import { UiSessionState } from '/imports/utils/UiState';

const connectionIdState = UiSessionState.valueProp('id', ConnectionId);

export const connection = {
  get id() {
    return connectionIdState.get();
  },
};

export const socket: Socket<ServerToClientEvents, ClientToServerEvents> = io('/cx', {
  parser,
  transports: ['websocket'],
  query: connection.id ? { connectionId: connection.id } : undefined,
});

socket.on('initConnection', ({ connectionId }) => {
  connectionIdState.set(connectionId);
  console.debug('Socket connection established');
});
